<template>
  <van-popup
    :value="show"
    position="left"
    :close-on-click-overlay="true"
    class="popupReport main-popup-report"
    @open="onOpen"
    @click-overlay="closePopup"
    >

    <van-tabs v-model="activeName"  >
      <van-tab name="report" title="Scegli la stampa">
        <van-cell-group>
          <van-cell v-for="(stampa, index) in stampe.filter(x => x.nomeReport)"
            :border="false"
            :key="index"
            :title="stampa.titolo"
            :label="stampa.descrizione"
            :note="stampa.note"
            @click="selectReport(stampa)" is-link/>
        </van-cell-group>
      </van-tab>
      <van-tab name="filtri" title="Filtri e Gruppi">
        <van-cell-group>
          <van-cell :title="report.titolo" :label="report.descrizione" title-class="titleClass" :border="false"/>
          <component v-for="(el, index) in filtriApplicabili" :key="index"
            :is="'Par' + el.type"
            :name="'Par' + el.type + String(index)"
            :elemento="el"
            :minDate="minDate"
            @change="componentValueChange"
          >
          </component>
        </van-cell-group>
        <van-button type="primary" block @click="stampaReport" class="buttonStampa">Stampa</van-button>
      </van-tab>
    </van-tabs>
    <div class="command-popup-report">
      <van-button @click="closePopup" type="info">Torna alla Cassa</van-button>
    </div>
  </van-popup>
</template>

<script>
/* eslint-disable */
import moment from 'moment'
import configurazioni from '@/services/configurazioniService.js'
import ParData from './elementi/data'
import ParDataOra from './elementi/dataOra'
import ParMultiselect from './elementi/multiselect'
import ParSwitch from './elementi/switch'
import lodash from 'lodash'

export default {
props: {
  show: Boolean,
  context: Object
},
components: { ParData, ParMultiselect, ParSwitch, ParDataOra },
data() {
  return {
    activeName: 'report',
    stampe: [],
    minDate: new Date(2021, 0, 1),
    report: {},
    filtri: {},
    pathReportPrefix: ''
  }
},
async mounted() {
  this.onOpen()
  const stampe = await configurazioni.getConfigurazione('report', 'report')
  this.stampe = stampe.filter(x => !x.nascondiSuElenco)
},
computed: {
  filtriApplicabili() {
    return this.report.filtri ? this.report.filtri.filter(x => x.type) : []
  },
  kbInput () {
    const res = this.$store.getters.popupKeyboardInput
    return res.key
  },
  kbKeyPress() {
    const res = this.$store.getters.keyPressPopupKeyboard
    return res.key
  },
  kbCounter() {
    const res = this.$store.getters.keyPressPopupKeyboard
    return res.count
  },
  listResult() {
    return this.$store.getters.listResult
  }
},
watch: {
  kbInput(value) {
    if (this.show) {
      const variabile = this.activeField
      const valore = String(value)
      this[variabile] = valore
      this.handleKey(valore)
    }
  },
  kbKeyPress(value) {
    if (this.show) {
      if (value === '{esci}') {
        this.closePopup()
      } else {
        this.handleKey(this.kbInput)
      }
    }
  },
  kbCounter(value) {
    if (this.show) {
      if (this.kbKeyPress === '{esci}') {
        this.closePopup()
      } else {
        this.handleKey(this.kbInput)
      }
    }
  }
},
created() {
  this.pathReportPrefix = process.env.VUE_APP_service_reporting || ''
},
methods: {
  getStilePopup() {
    var cont = document.querySelector('.main-popup-report')
    if (cont) {
      return `height: "50%"; width: ${cont.offsetWidth}px`
    } else {
      return 'height: "50%";'
    }
  },
  selectReport(stampa) {
    this.activeName = 'filtri'
    this.report = stampa
  },
  componentValueChange(model, value) {
    this.filtri[model] = value
    console.log(model, value)
  },
  async stampaReport() {
    const source = await this.preparaRichiesta('pdfm')
    if (source) {
      this.$router.push({ name: 'Pdf', params: { source: source } })
    }
  },
  async preparaRichiesta(tipo, batchResult) {
    const nomeReport = this.report.nomeReport
    const nonCompleti = false
    console.log('this.report.filtri', this.report.filtri)
    /*       this.report.filtri.forEach(el => {
      if (el.required && !el.value) {
        nonCompleti = true
      }
    }) */
    if (nonCompleti) {
      this.datiNonCompleti = true
      return ''
    } else {
      const start = this.filtri.dataDa ? moment(this.filtri.dataDa, 'DD/MM/YYYY').format('YYYYMMDD') : 'ddd' // nel caso il report non li prevedesse
      // TODO: Sistemare. Aggiungere un giorno non è corretto. Andrebbe usato endOf('day'), ma vanno rivisti tutti i report che utilizzano il filtro
      const stop = this.filtri.dataA ? moment(this.filtri.dataA, 'DD/MM/YYYY').add(1, 'days').format('YYYYMMDD') : 'aaa'
      let startOrario = this.filtri.dataDa ? moment(this.filtri.dataDa, 'DD/MM/YYYY hh:mm') : 'ddd'
      let endOrario = this.filtri.dataA ? moment(this.filtri.dataA, 'DD/MM/YYYY hh:mm') : 'aaa'
      if (startOrario.toString() === endOrario.toString()) {
        startOrario = null
        endOrario = null
      }
      const filtriAggiuntivi = []
      let filtriCustom = null
      const esclusi = ['mostraArticoli', 'includiGiacenzaPositiva', 'includiGiacenzaNegativa', 'includiGiacenzaNulla', 'valorizzaPrezzo', 'tipoApplicazione']
      this.report.filtri.filter(x =>
        !['dataDa', 'dataA'].includes(x.model) &&
        (x.model && !x.model.startsWith('rag-') && !x.model.startsWith('new-') &&
        !esclusi.includes(x.model))).forEach(el => {
        var ff
        if (typeof this.filtri[el.model] === 'boolean') {
          ff = this.filtri[el.model]
        } else {
          ff = lodash.pickBy(this.filtri[el.model])
        }
        if (this.filtri[el.model] && ff) {
          if (typeof this.filtri[el.model] === 'boolean') {
            filtriAggiuntivi.push({ chiave: el.model, valori: ff, applicazione: el.applicazione })
          } else {
            if (el.filtroRecord) {
              filtriCustom = {
                selector: el.model,
                value: Object.values(ff)
              }
              if (el.command) {
                filtriCustom.command = el.command
              }
            }
            filtriAggiuntivi.push({ chiave: el.model, valori: Object.values(ff), applicazione: el.applicazione })
          }
        } else {
          filtriAggiuntivi.push({ chiave: el.model, valori: [], applicazione: el.applicazione }) // serve il tipo applicazione per eventuale raggruppamento
        }
      })
      const raggruppamenti = []
      const newPage = []
      Object.keys(this.filtri).filter(x => x.startsWith('rag-')).forEach(el => {
        console.log('-->', el)
        const chiave = el.substring(4)
        if (chiave === 'data') {
          raggruppamenti.push({ chiave: 'data', applicazione: 'movimenti' })
        } else if (chiave === 'codice') {
          raggruppamenti.push({ chiave: 'codice', applicazione: 'prodotti' }) // verificare
        } else {
          const filtro = this.report.filtri.find(x => x.model === chiave)
          raggruppamenti.push({ chiave: filtro.model, applicazione: filtro.applicazione, stampa: filtro.modelPrint || filtro.model })
        }
      })
      Object.keys(this.filtri).filter(x => x.startsWith('new-')).forEach(el => {
        console.log('-->', el)
        const chiave = el.substring(4)
        if (chiave === 'data') {
          newPage.push({ chiave: 'data', applicazione: 'movimenti' })
        } else {
          const filtro = this.report.filtri.find(x => x.model === chiave)
          newPage.push({ chiave: filtro.model, applicazione: filtro.applicazione, stampa: filtro.modelPrint || filtro.model })
        }
      })
      // TODO: Andrebbe definito un payload generico invece di separare tutte le variabili ...
      const articoli = this.filtri.mostraArticoli ? this.filtri.mostraArticoli : false
      const giacenza = {
        positiva: this.filtri ? this.filtri.includiGiacenzaPositiva : false,
        nulla: this.filtri ? this.filtri.includiGiacenzaNulla : false,
        negativa: this.filtri ? this.filtri.includiGiacenzaNegativa : false
      }
      const valorizza = this.filtri && this.filtri.valorizzaPrezzo === 1 ? 'vendita' : 'acquisto'
      const tipoApplicazione = this.filtri ? this.filtri.tipoApplicazione : 0

      let impostazioni = null
      if (this.report.impostazioni) {
        if (typeof this.report.impostazioni === 'string') {
          const conf = this.report.impostazioni.split('.')
          if (conf && conf.length === 2) {
            impostazioni = await configurazioni.getConfigurazione(conf[0], conf[1])
          } else {
            impostazioni = this.report.impostazioni // TODO: Verificare.
          }
        } else {
          impostazioni = this.report.impostazioni // TODO: Verificare
        }
      }
      const parametri = {
        // TODO--> togliere la sezione intestazione. Vanno aggiornati tutti i database dei clienti
        intestazione: {
          titolo: this.report.descrizione,
          titolo_01_sx: this.report.titolo_01_sx,
          titolo_02_sx: this.report.titolo_02_sx,
          titolo_01_cx: this.report.titolo_01_cx
        },
        caricaLoghi: this.report.caricaLoghi || false,
        autoPrint: this.report.autoPrint || false,
        reportHeader: this.report.reportHeader || null,
        pageHeader: this.report.pageHeader || null,
        pageFooter: this.report.pageFooter || null,
        reportFooter: this.report.reportFooter || null,
        articoli: articoli,
        filtri: filtriAggiuntivi,
        filtriCustom: filtriCustom,
        gruppi: raggruppamenti,
        newPage: newPage,
        impostazioni: impostazioni,
        giacenza: giacenza,
        valorizza,
        tipoApplicazione,
        dettaglio: this.report.dettaglio,
        startOrario,
        endOrario,
        batchResult: !!batchResult
      }

      const str = JSON.stringify(parametri)
      // const source = `${this.pathReportPrefix}/reporting/pdfm/${nomeReport}/${start}/${stop}?par=${btoa(str)}`
      const buff = Buffer.from(str, 'utf-8')
      const source = `${this.pathReportPrefix}/reporting/${tipo || 'pdfm'}/${nomeReport}/${start}/${stop}?par=${buff.toString('base64')}`
      // this.$router.push({ name: 'Pdf', params: { source: source } })
      return source
    }
  },
  /*     openFluentReports() {
    const nomeReport = this.report.nomeReport
    console.log(nomeReport)
    let nonCompleti = false
    this.report.filtri.forEach(el => {
      if (el.required && !this.filtri[el.model]) {
        nonCompleti = true
      }
    })
    if (nonCompleti) {
      this.$toast('Dati non completi, verificare...', { type: 'fail', duration: 20000 })
    } else {
      const start = this.filtri.dataDa ? moment(this.filtri.dataDa, 'DD/MM/YYYY').format('YYYYMMDD') : 'ddd' // nel caso il report non li prevedesse
      const stop = this.filtri.dataA ? moment(this.filtri.dataA, 'DD/MM/YYYY').format('YYYYMMDD') : 'aaa'

      const filtriAggiuntivi = []
      this.report.filtri.filter(x => !['dataDa', 'dataA'].includes(x.model) && (x.model && !x.model.startsWith('rag-') && x.model !== 'mostraArticoli')).forEach(el => {
        const ff = lodash.pickBy(this.filtri[el.model])
        if (this.filtri[el.model] && ff) {
          filtriAggiuntivi.push({ chiave: el.model, valori: Object.keys(ff), applicazione: el.applicazione })
        } else {
          filtriAggiuntivi.push({ chiave: el.model, valori: [], applicazione: el.applicazione }) // serve il tipo applicazione per eventuale raggruppamento
        }
      })
      const raggruppamenti = []
      console.log(this.filtri)
      console.log(this.report.filtri)
      Object.keys(this.filtri).filter(x => x.startsWith('rag-')).forEach(el => {
        console.log('-->', el)
        const chiave = el.substring(4)
        if (chiave === 'data') {
          raggruppamenti.push({ chiave: 'data', applicazione: 'movimenti' })
        } else {
          const filtro = this.report.filtri.find(x => x.model === chiave)
          raggruppamenti.push({ chiave: filtro.model, applicazione: filtro.applicazione, stampa: filtro.modelPrint || filtro.model })
        }
      })
      const articoli = this.filtri.mostraArticoli ? this.filtri.mostraArticoli : false
      const parametri = {
        intestazione: {
          titolo: this.report.descrizione,
          titolo_01_sx: this.report.titolo_01_sx,
          titolo_02_sx: this.report.titolo_02_sx
        },
        articoli: articoli,
        filtri: filtriAggiuntivi,
        gruppi: raggruppamenti
      }
      console.log(parametri)
      const str = JSON.stringify(parametri)
      // TODO: Verificare, altrimenti correggere con path.combine
      // window.open(`${this.pathReportPrefix}/reporting/pdfm/${nomeReport}/${start}/${stop}?par=${btoa(str)}`)
      const source = `${this.pathReportPrefix}/reporting/pdfm/${nomeReport}/${start}/${stop}?par=${btoa(str)}`
      this.$router.push({ name: 'Pdf', params: { source: source } })
    }
  }, */
  onOpen() {
  },
  closePopup() {
    this.$emit('close')
  }
}
}
</script>

<style lang="scss" scoped>
@import "./style.scss";

.van-field__control {
  width: auto;
}

.ddTitleClass {
  justify-content: left;
}

.titleClass {
  text-align: center;
  color: red;
}

.buttonStampa {
  margin-top: 20px;
}

.swipe-cell-button {
  height: 100%;
}
.van-search .van-cell {
  padding: 10px 16px;
}

.van-search--show-action {
    padding-right: 12px;
}

@media all and (min-width:480px) {}
@media all and (min-width:768px) {
  .popupReport, .main-popup-report {
    width: 75%;
    height: 100%;
  }
}
@media all and (min-width:1024px) {
  .popupReport, .main-popup-report {
    width: 55%;
    height: 100%;
  }
}
@media all and (min-width:1400px) {
  .main-popup-report {
    width: 30%;
    height: 100%;
  }
}
</style>
